import Generic from './generic'

class Group extends Generic {

}

export default Group
